// DS: i4.30
import React from 'react';
import IconWrap from '../../IconWrap';
const SubmitPostPoll = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9 4a1 1 0 011-1h4a1 1 0 011 1v16a1 1 0 01-1 1h-4a1 1 0 01-1-1V4zM3 14a1 1 0 011-1h3a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM17 10a1 1 0 00-1 1v9a1 1 0 001 1h3a1 1 0 001-1v-9a1 1 0 00-1-1h-3z"
    })));
SubmitPostPoll.displayName = 'SubmitPostPoll';
export default SubmitPostPoll;
